export const THEME = process.env.REACT_APP_THEME_KEY;
export const API_KEY = process.env.REACT_APP_NEWS_API_KEY;
export const API = process.env.REACT_APP_NEWS_API;
export const HEADLINES_ENDPOINT =
	process.env.REACT_APP_NEWS_API_ENDPOINT_HEADLINES;
export const SEARCH_ENDPOINT = process.env.REACT_APP_NEWS_API_ENDPOINT_SEARCH;
